import { TextField, Stack } from "@mui/material";

export default function OrderInputText({ text, setText, label, isError }) {
    return (
        <Stack
            direction="row"
            spacing={2}
            alignItems="center"
            justifyContent="center"
        >
            <TextField
                label={isError ? "Order not found" : label === "" ? "Your order code" : label}
                variant="outlined"
                size="small"
                value={text}
                onChange={(e) => setText(e.target.value)}
                error={isError}
            />
        </Stack>
    );
}

